import { url } from '../../axios/api_urls/trend'
const api = require('../../axios/request')
import {getDictionary} from '../../axios/api/dictionary'
import {
  getUserData
} from '@/axios/api/userGroup'
import Vue from 'vue'

const UPDATE_STATE = 'UPDATE_STATE'
const UPDATE_OPTIONS = 'UPDATE_OPTIONS'
const UPDATE_USER = 'UPDATE_USER'
const UPDATE_USER_GROUP = 'UPDATE_USER_GROUP'
const UPDATE_LIST_DATA = 'UPDATE_LIST_DATA'
const UPDATE_LIST_TOTAL = 'UPDATE_LIST_TOTAL'
const UPDATE_HIGH_LIGHT = 'UPDATE_HIGH_LIGHT'
const UPDATE_FILTER = 'UPDATE_FILTER'

const state = {
  maxSize: {
    img: 10,
    image: 10,
    ppt: 200,
    pdf: 20,
    file: 20, // 新增image, pdf 和 ppt并保留file, 免得影响其他地方的代码
    video: 200,
    videoPicture: 10
  },
  options: {
    source: {
      id: 72,
      list: []
    },
    lifestyle: {
      pid: 1, // 从另一个接口拿
      list: []
    },
    segment: {
      pid: 2, // 从另一个接口拿
      list: []
    },
    targetDemographicCare: {
      id: 58,
      list: []
    },
    year: {
      id: 177,
      list: []
    },
    productFocus: {
      id: 63,
      list: []
    },
    country: {
      id: 134,
      list: []
    },
    language: {
      id: 28,
      list: []
    },
    position: {
      id: 167,
      list: []
    },
    rank: {
      id: 190,
      list: []
    },
    brandFocus: {
      id: 259,
      list: []
    }
  },
  // 上传与管理
  backUpload: null,
  backFilter: {
    desc: [],
    asc: [],
    date: []
  },
  backPage: {
    total: 0,
    current: 1,
    size: 10
  },
  // elite 3
  pcTabActive: null,
  pcTabList: null,
  pcTabData: [],
  pcFilter: {
    descId: undefined,
    keywordsIdList: []
  },
  pcPage: {
    total: 0,
    current: 1,
    size: 12
  },
  // CIDSId: null,
  dliteTabList: [],
  dliteKeyword: [],
  userList: [],
  userGroup: [],
  listData: [],
  listTotal: 0,
  highLight: false
}
const getters = {
  options: state => state.options,
  maxSize: state => state.maxSize,
  // 上传与管理
  backUpload: state => state.backUpload,
  backFilter: state => state.backFilter,
  backPage: state => state.backPage,
  // elite 3
  pcTabActive: state => state.pcTabActive,
  pcTabList: state => state.pcTabList,
  pcTabData: state => state.pcTabData,
  pcFilter: state => state.pcFilter,
  // CIDSId: state => state.CIDSId,
  pcPage: state => state.pcPage,
  dliteTabList: state => state.dliteTabList,
  dliteKeyword: state => state.dliteKeyword,
  userList: state => state.userList.map(v => {
    return {
      label: v.name,
      value: v.id
    }
  }),
  userGroup: state => state.userGroup.map(v => {
    return {
      label: v.groupName,
      value: v.id
    }
  }),
  listData: state => state.listData,
  listTotal: state => state.listTotal,
  highLight: state => state.highLight
}
const mutations = {
  [UPDATE_STATE] (context, payload) {
    context[payload.key] = payload.value
  },
  [UPDATE_OPTIONS] (context, payload) {
    context.options[payload.key].list = payload.value
  },
  [UPDATE_USER] (state, userList) {
    state.userList = userList
  },
  [UPDATE_USER_GROUP] (state, userGroup) {
    state.userGroup = userGroup
  },
  [UPDATE_LIST_DATA] (state, data) {
    state.listData = data
  },
  [UPDATE_LIST_TOTAL] (state, data) {
    state.listTotal = data
  },
  [UPDATE_FILTER] (state, backFilter) {
    state.backFilter = {
      ...backFilter
    }
  },
  setPCTab (context, payload) {
    context.dliteTabList.some(item => {
      if(item.id === payload){
        let arr = []
        context.pcTabActive = item.id/1
        arr = Array.from(item.child) || []
        if (item.child && item.child.length) {
          arr.unshift({
            id: 0,
            webImgSrc: item.webImgSrc,
            title: item.title
          })
        }
        context.pcTabData = arr
      }
    })
    context.pcPage = {
      total: 0,
      current: 1,
      size: 12
    }
  },
  [UPDATE_HIGH_LIGHT] (state, highLight) {
    state.highLight = highLight
  }
}
const actions = {
  // 获取后台，筛选项，可选项
  initList ({state, commit}) {
    for (let key in state.options) {
      let {id, pid, list} = state.options[key]
      if (!list.length){
        if (id) {
          getDictionary(id).then(res => {
            commit('UPDATE_OPTIONS', {key, value: res.data || []})
          })
        } else if (pid) {
          api._post(url.lifestyleSegmentList, {pid}).then(res => {
            commit('UPDATE_OPTIONS', {key, value: res.data || []})
          })
        }
      }
    }
  },
  // 上传大小限制
  checkSize ({state}, payload) {
    // 现在有ppt, pdf, file, video, img, image这几种种类
    return new Promise((resolve, reject) => {
      if (payload.size > state.maxSize[payload.type] * 1024 * 1024) {
        // payload._this.$message.error(`${payload._this.$t('txt.file')} ${payload._this.$t('message.fileMaxSize')} ${state.maxSize[payload.type]}M`)
        reject(false)
      } else {
        resolve(true)
      }
    })
  },
  unreadManage({state}, payload){
    return api._post(url.unreadManage)
  },
  unreadUpload({state}, payload){
    return api._post(url.unreadUpload)
  },
  getUploadTrendCount({state}, payload){
    return api._post(url.getUploadTrendCount)
  },
  /*
  *
  * 审核与上传
  * */
  // 所有列表
  // getAllTrendList (context, payload) {
  //   return api._post(url.allList, payload)
  // },
  // 上传者列表
  getMyTrendList (context, payload) {
    return api._post(url.myList, payload)
  },
  // 审核者列表
  getCheckTrendList (context, payload) {
    return api._post(url.checkList, payload)
  },
  userList (context, payload = '') {
    return api._post(url.userList, {keyword: payload, size: 10000}) // 由于测试需要所有用户列表，后台默认size:10，所以传个大数值
  },
  approverList (context, payload = '') {
    return api._post(url.approverList, {keyword: payload})
  },
  // 预览
  getMyPreview (context, payload) {
    return api._post(url.preview, {id: payload})
  },
  getCheckPreview (context, payload) {
    return api._post(url.checkPreview, {id: payload})
  },
  // 详情
  getMyDetail (context, payload) {
    return api._post(url.detail, {id: payload})
  },
  getCheckDetail (context, payload) {
    return api._post(url.checkDetail, {id: payload})
  },
  // 所有里面edit详情
  getTrendAllDetail (context, payload) {
    return api._post(url.detailAll, {id: payload})
  },
  // 撤回和提交
  submitWithdraw (context, payload) {
    return api._post(url.submitWithdraw, payload)
  },
  approval (context, payload) {
    return api._post(url.judge, payload)
  },
  enableTrending (context, payload) {
    return api._post(url.enableTrending, payload)
  },
  changeStatus (context, payload) {
    return api._post(url.changeStatus, payload)
  },
  setTrending (context, payload) {
    return api._post(url.setTrending, payload)
  },
  upload (context, payload) {
    const { file, path, type } = payload
    const uploadUrl = type === 'pdf' ? url.uploadWatermark : url.upload
    return api._upload(uploadUrl, {
      file,
      path
    })
  },
  getKeyword (content, payload="") {
    return api._post(url.key, {
      current: 1,
      size: 50,
      desc: ['id'],
      keyword: payload
    })
  },
  newKeyword (content, payload) {
    return api._post(url.addKey, payload)
  },
  addTrend (content, payload) {
    return api._post(url.addTrend, payload)
  },
  editTrend (content, payload) {
    return api._post(url.editTrend, payload)
  },
  updateTrend (content, payload) {
    return api._post(url.updateTrend, payload)
  },
  exportsFile (content, payload) {
    return api._post(url.exports, payload)
  },
  /*
  *
  * Life&Segment
  * */
  getLifeSegment(content, payload) {
    return api._post(url.lifeSegment, payload)
  },
  enableLifeSegment(content, payload) {
    return api._post(url.enableLifeSegment, payload)
  },
  addLifeSegment(content, payload) {
    return api._post(url.addLifeSegment, payload)
  },
  editLifeSegment(content, payload) {
    return api._post(url.editLifeSegment, payload)
  },
  lifeSegmentDetail(content, payload) {
    return api._post(url.lifeSegmentDetail, payload)
  },
  ableRank(content, payload) {
    return api._post(url.ableRank, payload)
  },
  saveKeyword(content, payload) {
    return api._post(url.saveKeyword, {keyword: payload})
  },
  updateKeyword(content, payload) {
    return api._post(url.updateKeyword, payload)
  },
  enableKeyword(content, payload) {
    return api._post(url.enableKeyword, payload)
  },
  getAllKeywordList(content, payload) {
    return api._post(url.keywordList, payload)
  },
  /*
  *
  * Trend PC
  * */
  getDliteTabList({commit, state}, payload) {
    return api._post(url.dliteTabList, payload).then(res => {
      let list = []
      res.data.map(item => {
        list.push({
          label: item.title,
          value: item.id
        })
        // if (item.title === "CIDS") {
        //   commit(UPDATE_STATE, {key: 'CIDSId', value: item.id})
        // }
      })
      commit(UPDATE_STATE, {key: 'dliteTabList', value: res.data || []})
      commit('setPCTab', state.pcTabActive || res.data[0].id || null)
      // commit(UPDATE_STATE, {key: 'pcTabActive', value: state.pcTabActive || res.data[0].title || null})
      // commit(UPDATE_STATE, {key: 'pcTabData', value: res.data[0].child || []})
      commit(UPDATE_STATE, {key: 'pcTabList', value: list || []})
    })
  },
  dliteList({commit}, payload) {
    return api._post(url.dliteList, payload)
  },
  dliteDetail({commit}, payload) {
    return api._post(url.dliteDetail, {id: payload})
  },
  getDliteKeyword({commit}, payload) {
    return api._post(url.deliteKeyword, payload).then(res => {
      commit(UPDATE_STATE, {key: 'dliteKeyword', value: res.data || []})
      return res
    })
  },
  // 获取用户下拉
  async getUserDataApi ({commit}, params) {
    try {
      const { data: res } = await getUserData(params)
      commit(UPDATE_USER, res)
    } catch (e) {}
  },
  async getListDataApi ({commit}, params) {
    try {
      const { data: { data, total } } = await api._post(url.dliteList, params)
      commit(UPDATE_LIST_DATA, data || [])
      commit(UPDATE_LIST_TOTAL, total || 0)
    } catch (e) {}
  },
  async getLastUpdateTimeApi ({ state, commit }, params) {
    try {
      let { data: res } = await api._post(url.getLastUpdateTime, params)
      return res
    } catch (e) {
      return {}
    }
  },
  async getHighLightApi ({ state, commit }) {
    try {
      const params = {
        current: 1,
        desc: ['trendingSort'],
        size: 1
      }
      let { data: res } = await api._post(url.getHighLight, params)
      commit(UPDATE_HIGH_LIGHT, res.data[0] || false)
    } catch (e) {
      return false
    }
  },
  async deleteDraftApi ({ commit }, params) {
    try {
      const res = await api._post(url.deleteDraft, params)
      return res && res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  // 设置 Key focus product
  async setKeyProductApi ({ commit }, params) {
    try {
      const res = await api._post(url.setKeyProduct, params)
      return res
    } catch (e) {
      return false
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trend.js